import { pad, trimStart } from 'lodash'

export function integerWithCommasInputMask (input) {
  const digits = input.toString().replace(/[^0-9]/g, '').length
  return trimStart(pad('', digits, '#').replace(/\B(?=(['#']{3})+(?!['#']))/g, ','), ',')
}
